import mergeClasses from '../../../utils/shallowMerge';
import useDebounce from '../../../utils/useDebounce';
import Button from '../button';
import BackToTopIcon from '../icons/BackToTopIcon';
import defaultClasses from './BackToTop.module.scss';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { useCustomScrollToTop } from '../../../utils/useCustomScrollToTop';

const BackToTop = ({
  customClasses = null,
  scrollThreshold = 200
}) => {
  const blockRef = useRef({});
  const styles = mergeClasses(defaultClasses, customClasses);

  const [isShown, setIsShown] = useState(false);

  const customStyle = clsx(styles.root, { [styles.shown]: isShown });

  const { goToTop } = useCustomScrollToTop(blockRef);

  const buttonProps = {
    variant: 'primary',
    as: 'button',
    className: styles.button,
    shape: 'rounded',
    'aria-label': 'Go Up',
  };

  const debouncedHandler = useDebounce(() => {
    const { top: innerDivTopPosition } =
      blockRef.current.innerDiv.getBoundingClientRect();
    setIsShown(Math.abs(innerDivTopPosition) > scrollThreshold);
  }, 50);

  useEffect(() => {
    if (blockRef?.current) {
      blockRef?.current?.body?.addEventListener('scroll', debouncedHandler);
    }
    return () => {
      if (blockRef?.current) {
        blockRef?.current?.body?.removeEventListener(
          'scroll',
          debouncedHandler,
        );
      }
    };
  }, [blockRef]);

  return (
    <div className={customStyle}>
      <Button
        {...buttonProps}
        as="pill"
        onClick={() => {
          goToTop();
        }}
      >
        <BackToTopIcon width="20px" height="20px" />
      </Button>
    </div>
  );
};

BackToTop.propTypes = {
  scrollThreshold: PropTypes.number,
  customClasses: PropTypes.shape({
    root: PropTypes.string,
    shown: PropTypes.string,
    button: PropTypes.string,
    messageSvg: PropTypes.string,
  }),
};

export default BackToTop;
